import { MatSnackBarConfig } from '@angular/material/snack-bar';

export const matSnackBarDefaultConfig: MatSnackBarConfig = {
  duration: 7000,
  verticalPosition: 'top',
  panelClass: 'toast'
};